import { isAnyFacilityPage } from '../../utils/kitchen-growth-helpers';

// Function to get UTM parameters for current url
export const getUTMParam = () => {
  const urlString = window.location.href;
  const url = new URL(urlString);

  const utmSource = url.searchParams.get('utm_source') || '';
  const utmCampaign = isAnyFacilityPage()
    ? 'Facility Finder'
    : url.searchParams.get('utm_campaign') || '';
  const utmMedium = url.searchParams.get('utm_medium') || '';
  const utmTerm = url.searchParams.get('utm_term') || '';
  const utmContent = url.searchParams.get('utm_content') || '';
  const utmChannel = url.searchParams.get('utm_channel') || '';

  return {
    utmSource,
    utmCampaign,
    utmMedium,
    utmTerm,
    utmContent,
    utmChannel,
  };
};

// Function to get GCLID parameters for current url
export const getGCLIDParam = () => {
  const urlString = window.location.href;
  const url = new URL(urlString);

  const gclid = url.searchParams.get('gclid') || '';

  return { gclid };
};
